import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';

export const ImprimirPartidasSubCreaReduV = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [tipo, setTipo] = useState(0);
    const [desde, setDesde] = useState('');
    const [hasta, setHasta] = useState('');
    const [condi, setCondi] = useState('');
    const [desdepago, setDesdepago] = useState('');
    const [hastapago, setHastapago] = useState('');
    const [activo, setActivo] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtGastos = useRef();
    const txtIngresos = useRef();
    const txtDesde = useRef();
    const txtHasta = useRef();
    const txtDesdePago = useRef();
    const txtHastaPago = useRef();
    const txtCheck = useRef();

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtDesde.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha Desde no debe ir Vacio!', icono: 'informacion' });
            sigue = false;
            txtDesde.current.focus();
        } else if (txtHasta.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha Hasta no debe ir Vacio!', icono: 'informacion' });
            sigue = false;
            txtHasta.current.focus();
        }

        else if (sigue) {
            imprimirGeneral(desde, hasta, desdepago, hastapago, tipo, condi)
        }

    };

    const onChange = (e) => {

        if (e.target.id === 'desde') {
            setDesde(e.target.value);
        } else if (e.target.id === 'hasta') {
            setHasta(e.target.value);
        } else if (e.target.id === 'desdepago') {
            setDesdepago(e.target.value);
        } else if (e.target.id === 'hastapago') {
            setHastapago(e.target.value);
        }
    };

    const onCheck = () => {

        if (txtGastos.current && txtGastos.current.checked) {
            setTipo(4);
            setActivo(false);
        } else if (txtIngresos.current && txtIngresos.current.checked) {
            setTipo(3);
            setActivo(false);
        }

        /* if (props.condicion === 'Nivel de Partidas' || props.condicion === 'Nivel de SubEspecificas') {
            if (txtCheck.current.checked === true) {
                setCondi("alcaldia = true");
            } else if (txtCheck.current.checked === false) {
                setCondi("TRUE");
            }
        } */

    }

    const imprimirGeneral = (desde, hasta, desdepago, hastapago, tipo, condi) => {

        var reporte = "";
        var sql = "";
        var sql1 = "";
        var sql2 = "";
        var pgau = "";
        var pgad = "";
        let desdec = moment.utc(desde).format('DD-MM-YYYY');
        let hastac = moment.utc(hasta).format('DD-MM-YYYY');
        let desdep = moment.utc(desdepago).format('DD-MM-YYYY');
        let hastap = moment.utc(hastapago).format('DD-MM-YYYY');
        var val = 0;

        if (props.condicion === 'Aumento y/o Crédito Adicional') {

            if (espiritu === 8) {
                reporte = 'Pres_SE_Aum1';
            } else {
                reporte = 'Pres_SE_Aum_a';
            }

            sql = "Fecha Between" + "'" + desdec + "'" + " AND " + "'" + hastac + "'";
            sql1 = "DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA EL" + " " + "'" + hastac + "'";

            if (tipo === 4) {
                sql2 = " DE GASTOS";
            } else if (tipo === 3) {
                sql2 = " DE INGRESOS";
            }

        } else if (props.condicion === 'Reducción') {

            reporte = 'Pres_SE_Dism';

            sql = "Fecha Between " + "'" + desdec + "'" + " AND " + "'" + hastac + "'";
            sql1 = "DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA EL" + " " + "'" + hastac + "'";

        } else if (props.condicion === 'Nivel de Partidas') {

            reporte = 'Pres_PAR_MovimGtos';

            //sql = condi;
            //sql = "Between " + "'" + desdec + "'" + " AND " + "'" + hastac + "'";
            sql = txtCheck.current.checked ? "alcaldia = true": "TRUE";
            sql1 = "DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA EL" + " " + "'" + hastac + "'";

        } else if (props.condicion === 'Nivel de SubEspecificas') {

            reporte = 'Pres_SE_EjecucionGtosMesSubEsp';

            //sql = condi;
            //sql = "true";
            sql = txtCheck.current.checked ? "alcaldia = true": "TRUE";
            sql1 = "DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA EL" + " " + "'" + hastac + "'";

        } else if (props.condicion === 'Nivel de SubEspecificas por Sector') {

            reporte = 'Pres_SE_MovimGtos2';
            val = 1;

            sql = "Between " + "'" + desdec + "'" + " AND " + "'" + hastac + "' ";
            sql1 = "Ejecutado DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA EL" + " " + "'" + hastac + "'";

            pgau = " (pagado Between '"+desdep+"' AND '"+hastap+"')";
            pgad = "Pagado DESDE EL" + " " + "'" + desdep + "'" + " " + "HASTA EL" + " " + "'" + hastap + "'";

        } else if (props.condicion === 'Partidas Creadas a Posteriori') {

            reporte = 'Pres_Adicional';

            sql = "Fecha Between" + "'" + desdec + "'" + " AND " + "'" + hastac + "'";
            sql1 = "DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA " + " " + "'" + hastac + "'";

        } else if (props.condicion === 'Relación de Gastos por Orden de Pago') {

            reporte = 'rendicion2';

            sql = "MOV.Fecha Between " + "'" + desdec + "'" + " AND " + "'" + hastac + "'";
            sql1 = "DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA EL" + " " + "'" + hastac + "'";

        } else if (props.condicion === 'Resumen de Proyectos') {

            reporte = 'rendicion';

            sql = "MOV.Fecha Between " + "'" + desdec + "'" + " AND " + "'" + hastac + "'";
            sql1 = "DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA EL" + " " + "'" + hastac + "'";

        } 


        window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&idfiscal=" + idefiscal + "&sql=" + sql + "&sql1=" + sql1 + "&sql2=" + sql2 + "&sql3=" + desdec + "&sql4=" + hastac + "&tipo=" + tipo + "&fpd=" + pgau + "&fph=" + pgad + "&val=" + val, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        txtDesde.current.value = '';
        txtHasta.current.value = '';
        setActivo(false);
        setTipo(0);
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                txtDesde.current.value = moment.utc(fechaSistema).format('YYYY-MM-DD');
                txtHasta.current.value = moment.utc(fechaSistema).format('YYYY-MM-DD');
                let fech = moment.utc(fechaSistema).format('YYYY-MM-DD');
                setHasta(fech);
                setDesde(fech);

                if (props.condicion === 'Nivel de SubEspecificas por Sector') {
                    let anio = parseInt(fechaSistema.substring(0, 4)) - 1;
                    let fechd = anio.toString() + '-01-01';
                    let fechh = anio.toString() + '-12-31';;
                    txtDesdePago.current.value = fechd;
                    txtHastaPago.current.value = fechh;
                    setDesdepago(fechd);
                    setHastapago(fechh);
                }

                if (props.condicion === 'Aumento y/o Crédito Adicional') {
                    setActivo(true);
                } else {
                    setActivo(false);
                }

                if (props.condicion === 'Nivel de Partidas' || props.condicion === 'Nivel de SubEspecificas') {
                    setCondi("TRUE");
                }
            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{'Imprimir ' + props.condicion}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='container-fluid rounded'>

                    <div className="tab-content" id="ex-with-icons-content">
                        <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                            <fieldset className="row border-azul rounded mx-auto">
                            <legend className="float-none m-0 w-auto" >Datos</legend>

                                <div className='row m-0 px-0 mb-2'>

                                    <div className='col-sm-4 mb-1 px-1 mx-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Desde Fecha:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtDesde} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="desde" />
                                        </div>
                                    </div>

                                    <div className='col-sm-4 mb-1 px-1 mx-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Hasta Fecha:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtHasta} max={moment.utc(fechaSistema).format('YYYY-MM-DD')} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="hasta" />
                                        </div>
                                    </div>

                                </div>

                               {props.condicion === 'Nivel de Partidas' || props.condicion === 'Nivel de SubEspecificas' ? <div className='col-sm-3 mb-1 border-azul rounded py-1'>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" ref={txtCheck} onChange={onCheck} type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label className="form-check-label" for="inlineCheckbox1">Solo Alcaldía</label>
                                    </div>
                                </div> : ''}

                                {props.condicion === 'Nivel de SubEspecificas por Sector' ? <div className='row m-0 px-0 mb-2'>

                                    <div className='col-sm-5 mb-1 px-1 mx-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Fecha de Pago Desde:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtDesdePago} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="desdepago" />
                                        </div>
                                    </div>

                                    <div className='col-sm-4 mb-1 px-1 mr-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Hasta Fecha:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtHastaPago} max={moment.utc(fechaSistema).format('YYYY-MM-DD')} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="hastapago" />
                                        </div>
                                    </div>

                                </div> : ''}


                                {props.condicion === 'Aumento y/o Crédito Adicional' ? <div className='row m-0 col-sm-10 px-0 border-azul rounded py-2 mx-auto'>
                                    <div className="form-check col-md-4 mx-auto mb-1">
                                        <input className="form-check-input" ref={txtGastos} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label" for="flexRadioDefault1">
                                            Partidas de Gastos
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 mx-auto mb-1">
                                        <input className="form-check-input" ref={txtIngresos} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label" for="flexRadioDefault2">
                                            Partidas de Ingresos
                                        </label>
                                    </div>
                                </div> : ''}

                            </fieldset>

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} disabled={activo} onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}